//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/ugmath.js";
let d=[[[0,"Associative",1,0],[0,"CurveSmoothRates",1,0],[1,"EndDistance",0,"Expression",0],[0,"ExtendMethod",1,0],[0,"FirstPoint",1,"Point",0],[0,"ManipulatorOldOrigin",1,0],[0,"ManipulatorOldOriginAvailable",1,0],[0,"ManipulatorOrigin",1,0],[0,"OriginalCurveLayer",1,0],[0,"OriginalCurveOperation",1,0],[0,"ReverseFirstPointTrimSide",1,0],[0,"ReverseSecondPointTrimSide",1,0],[0,"SecondPoint",1,"Point",0],[1,"StartDistance",0,"Expression",0],[0,"TangentShapeControlScaleValue",1,0],[0,"Type",1,0]],[[["pointNumber","selectedCurveTag"],"UpdatePointSelectedCurve",{},2,0],[["pointNumber"],"UpdateOutputCurve",{},1,0],[["pointNumber","trimLength","trimPoint"],"UpdateTrimLength",{},3,0],[[],"UpdateOutputCurveAfterMoveHandle",{},0,0],[["startDistance"],"UpdateStartDistanceExpStr",{},1,0],[["endDistance"],"UpdateEndDistanceExpStr",{},1,0]],[]];
SPLM.Tooling.EditCoolingCurveBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.EditCoolingCurveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.EditCoolingCurveBuilder.Types = Object.freeze({
    "Trim" : "Trim", "Extend" : "Extend", "Divide" : "Divide", "Bridge" : "Bridge", "Move" : "Move", "Drag" : "Drag"});

SPLM.Tooling.EditCoolingCurveBuilder.ExtensionMethod = Object.freeze({
    "Natural" : "Natural", "Linear" : "Linear", "Circular" : "Circular"});

SPLM.Tooling.EditCoolingCurveBuilder.OriginalCurveOperationType = Object.freeze({
    "None" : "None", "Hide" : "Hide", "MovetoLayer" : "MovetoLayer", "Delete" : "Delete"});

export default SPLM;